/**
 * Import from node_modules
 */
import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import Sliders from './site/sliders';
import SkipLinkFocusFix from './site/skip-link-focus-fix';
import Menu from './site/menu';
import ScrollTo from './site/scrollTo';
import Styleguide from './site/styleguide';
// import Fancybox from './site/fancybox';
//import Select2 from './site/select2';
import FormHelpers from './site/formHelpers';
import PerfectScroll from './site/perfectScroll';
import LazyLoading from './site/lazyLoad';
import LoadMoreBlog from './site/loadMoreBlog';
import ContactForm from './site/contactForm';
import Register from './site/register';
import AOS from 'aos';
import VariationScript from './site/variationScript';
import MainScripts from './site/mainScripts';
import updateSelectedProductOption from './site/updateSelectedProductOption';

/**
 * Init site scripts
 */
jQuery(function() {
	Sliders.init();
	SkipLinkFocusFix.init();
	Styleguide.init();
	Menu.init();
	ScrollTo.init();
	// Fancybox.init();
	//Select2.init();
	FormHelpers.init();
	PerfectScroll.init();
	LazyLoading.init();
	LoadMoreBlog.init();
	ContactForm.init();
	Register.init();
	VariationScript.init();
	MainScripts.init();
	updateSelectedProductOption.init();
	AOS.init({
		offset: 200,
		duration: 600,
		easing: 'ease-in-sine',
		delay: 100,
		once: true,
		disable: function() {
			const maxWidth = 1200;
			return window.innerWidth < maxWidth;
		}
	});
});
